import React from 'react'
import {
  PageHeader as AntPageHeader,
  PageHeaderProps as AntPageHeaderProps,
} from '@ant-design/pro-layout'
import styles from './PageHeader.module.scss'
import { clx } from 'Utils/clx'

export type PageHeaderProps = AntPageHeaderProps

const PageHeader: React.FC<PageHeaderProps> = ({
  children,
  title = null,
  extra,
  footer,
  breadcrumb,
  style,
}) => {
  return (
    <div data-id="page-header" style={{ width: '100%' }}>
      <AntPageHeader
        className={clx(styles['page-header'], 'studio__page-header')}
        title={title}
        extra={extra}
        footer={footer}
        breadcrumb={breadcrumb}
        style={{
          width: '100%',
          minHeight: '74px',
          backgroundColor: 'transparent',
          ...style,
        }}
      >
        {children}
      </AntPageHeader>
    </div>
  )
}

export default PageHeader
